import React from 'react';
import PropTypes from 'prop-types';

const SearchFailedOption = ({ innerProps, innerRef, label }) => (
  <div ref={innerRef} {...innerProps} className="entity text-danger">
    {label}
  </div>
);

SearchFailedOption.propTypes = {
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  label: PropTypes.string.isRequired
};

export default SearchFailedOption;
